import { TreeView } from "devextreme-react";
import React, {useEffect, useState} from "react";

const AssetFilter = ({assets = [], selected = [], onChange}) => {
  const [selectedAssets, setSelectedAssets] = useState(selected);

  useEffect(() => {
    setSelectedAssets(selected);
  }, [selected]);

  const handleToggle = (asset) => {
    const updated = selectedAssets.some((a) => a.id === asset.id)
      ? selectedAssets.filter((a) => a.id !== asset.id)
      : [...selectedAssets, asset];
    setSelectedAssets(updated);
    onChange?.(updated);
  };

  const isChecked = (asset) => selectedAssets.some((a) => a.id === asset.id);

  // Example render
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      {assets.map((asset) => (
        <label
          key={asset.id}
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            fontSize: 14,
            cursor: "pointer",
            padding: "4px 2px",
          }}
        >
          <input
            type="checkbox"
            checked={isChecked(asset)}
            onChange={() => handleToggle(asset)}
            style={{ cursor: "pointer" }}
          />
          <span>{asset.name}</span>
        </label>
      ))}
    </div>
  );
}

export default AssetFilter;